/** Theme tokens for account detail grids (matches demo-ui admin panel detail). */
export function buildAccountDetailTokens(dark, c, A) {
  const soft = (alpha) => `${A}${alpha}`;
  return {
    card: c.card,
    cardBorder: c.cardBdr,
    fieldLabel: A,
    fieldIconBg: dark ? soft("22") : soft("10"),
    fieldIconBorder: dark ? soft("38") : soft("25"),
    fieldIconColor: A,
    labelStrong: dark ? c.sub : c.mid,
    actionBtn: {
      border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : c.cardBdr}`,
      background: dark ? "rgba(255,255,255,0.04)" : c.card,
      hoverBg: dark ? "rgba(255,255,255,0.08)" : c.hover,
    },
  };
}

export function detailHeaderAccentStyle(A) {
  return { height: 2, background: `linear-gradient(90deg, ${A} 0%, ${A}55 45%, ${A}00 100%)` };
}

export function detailActionBtnStyle(ap, variant = "default") {
  if (variant === "danger") {
    return { width: 30, height: 30, borderRadius: 7, border: "1px solid #EF444440", background: "#EF444410", cursor: "pointer", color: "#EF4444", display: "flex", alignItems: "center", justifyContent: "center" };
  }
  return { width: 30, height: 30, borderRadius: 7, border: ap.actionBtn.border, background: ap.actionBtn.background, cursor: "pointer", color: "inherit", display: "flex", alignItems: "center", justifyContent: "center" };
}
